"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VISIBLE_GAMES_COUNT_OFFSET = void 0;
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var react_intersection_observer_1 = require("react-intersection-observer");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
exports.VISIBLE_GAMES_COUNT_OFFSET = 24;
var CARD_CLASS_NAME = 'game-card';
var GamesWithSearchAndPagination = function (_a) {
    var _b, _c, _d, _e;
    var title = _a.title, categoryId = _a.categoryId, providerId = _a.providerId, gameCardPlaceholder = _a.gameCardPlaceholder, place = _a.place, _f = _a.hasSearch, hasSearch = _f === void 0 ? true : _f, emptyGamesText = _a.emptyGamesText;
    var _g = (0, react_intersection_observer_1.useInView)({ threshold: 0.7 }), sentinelRef = _g.ref, inView = _g.inView;
    var _h = (0, swr_hooks_1.useCache)(), getDataFromCache = _h.getDataFromCache, setDataToCache = _h.setDataToCache;
    var config = (0, swr_hooks_1.useConfig)();
    var CURRENT_PAGE_GAMES_PAGINATION = (0, react_1.useMemo)(function () { return "current_page_games_pagination_".concat(place); }, [place]);
    var SEARCH_VALUE_GAMES_PAGINATION = (0, react_1.useMemo)(function () { return "search_value_games_pagination".concat(place); }, [place]);
    var SEARCH_RESULT_GAMES_PAGINATION = (0, react_1.useMemo)(function () { return "search_result_games_pagination".concat(place); }, [place]);
    var _j = (0, react_1.useState)(getDataFromCache(SEARCH_VALUE_GAMES_PAGINATION) || ''), searchValue = _j[0], setSearchValue = _j[1];
    var _k = (0, swr_hooks_1.useSearchGamesInWithPagination)({
        showCount: exports.VISIBLE_GAMES_COUNT_OFFSET,
        categoryId: Boolean(searchValue) && config.gameSearchWithoutCategory
            ? undefined
            : categoryId,
        providerId: providerId,
        place: place,
        successAction: function (results) {
            setDataToCache(SEARCH_RESULT_GAMES_PAGINATION, results);
        },
    }), data = _k.data, loadMore = _k.loadMore, search = _k.search, isSubmitting = _k.isSubmitting;
    var _l = (0, react_1.useState)(getDataFromCache(CURRENT_PAGE_GAMES_PAGINATION) || 0), currentPage = _l[0], setCurrentPage = _l[1];
    var t = (0, next_intl_1.useTranslations)('translation');
    var prevSearch = (0, react_1.useRef)(searchValue);
    var searchTimer = (0, react_1.useRef)(null);
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var onSearchChange = (0, react_1.useCallback)(function (_a) {
        var target = _a.target;
        setSearchValue(target.value);
        setCurrentPage(0);
        setDataToCache(SEARCH_VALUE_GAMES_PAGINATION, target.value);
    }, [setDataToCache, SEARCH_VALUE_GAMES_PAGINATION]);
    var searchClear = (0, react_1.useCallback)(function () {
        setSearchValue('');
        setCurrentPage(0);
        setDataToCache(SEARCH_VALUE_GAMES_PAGINATION, '');
    }, [setDataToCache, SEARCH_VALUE_GAMES_PAGINATION]);
    var handleLoadBtnClick = (0, react_1.useCallback)(function () {
        loadMore();
        setCurrentPage(currentPage + 1);
        setDataToCache(CURRENT_PAGE_GAMES_PAGINATION, currentPage + 1);
    }, [
        loadMore,
        currentPage,
        setCurrentPage,
        setDataToCache,
        CURRENT_PAGE_GAMES_PAGINATION,
    ]);
    var gamesToShow = (0, react_1.useMemo)(function () {
        var _a, _b, _c;
        return ((_b = (_a = getDataFromCache(SEARCH_RESULT_GAMES_PAGINATION)) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.edges) ||
            ((_c = data === null || data === void 0 ? void 0 : data.data) === null || _c === void 0 ? void 0 : _c.edges);
    }, [getDataFromCache, (_b = data === null || data === void 0 ? void 0 : data.data) === null || _b === void 0 ? void 0 : _b.edges, SEARCH_RESULT_GAMES_PAGINATION]);
    (0, react_1.useEffect)(function () {
        if (Object.keys(breakpoints).length === 0 ||
            (searchValue !== '' && searchValue.length < 1) ||
            prevSearch.current === searchValue)
            return;
        searchTimer.current = setTimeout(function () {
            var searchQuery = { title: searchValue };
            search(searchQuery);
        }, 200);
        prevSearch.current = searchValue;
        return function () {
            if (searchTimer.current)
                clearTimeout(searchTimer.current);
        };
    }, [breakpoints, search, searchValue]);
    (0, react_1.useEffect)(function () {
        var _a;
        if (inView &&
            !isSubmitting &&
            currentPage <
                Math.floor(Number(((_a = data === null || data === void 0 ? void 0 : data.data) === null || _a === void 0 ? void 0 : _a.totalCount) || 1) / exports.VISIBLE_GAMES_COUNT_OFFSET)) {
            handleLoadBtnClick();
        }
    }, [
        inView,
        isSubmitting,
        currentPage,
        (_c = data === null || data === void 0 ? void 0 : data.data) === null || _c === void 0 ? void 0 : _c.totalCount,
        handleLoadBtnClick,
    ]);
    if (!gamesToShow)
        return react_1.default.createElement(ui_components_1.LoadingWithContainer, null);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        hasSearch ? (react_1.default.createElement(ui_components_1.SearchWithTitle, { title: title, value: searchValue, searchClear: searchClear, onSearchChange: onSearchChange })) : (react_1.default.createElement("div", { className: styles_module_scss_1.default.title },
            react_1.default.createElement("h2", null, title))),
        (gamesToShow === null || gamesToShow === void 0 ? void 0 : gamesToShow.length) > 0 ? (react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: styles_module_scss_1.default.gamesContainer }, (_d = data === null || data === void 0 ? void 0 : data.data) === null || _d === void 0 ? void 0 : _d.edges.map(function (item) {
                var _a;
                return (react_1.default.createElement("div", { key: "provider_page".concat(item.id, "}") }, Object.keys(breakpoints).length > 0 &&
                    (breakpoints.mobile || breakpoints.tablet) ? (react_1.default.createElement(ui_components_1.MobileGameCard, { title: item.title, gameId: item.id, slug: item === null || item === void 0 ? void 0 : item.slug, className: CARD_CLASS_NAME, gameCardPlaceholder: gameCardPlaceholder, gameInfoModalKey: apps_shared_1.POPUP_CONSTANTS.GAME_INFO_MODAL })) : (react_1.default.createElement(ui_components_1.DesktopGameCard, { title: item.title, gameId: item.id, slug: item.slug, withDemo: (_a = item === null || item === void 0 ? void 0 : item.settings) === null || _a === void 0 ? void 0 : _a['demo'], className: CARD_CLASS_NAME, gameCardPlaceholder: gameCardPlaceholder, signUpModalKey: apps_shared_1.POPUP_CONSTANTS.SIGN_UP_MODAL }))));
            })),
            !isSubmitting &&
                currentPage <
                    Math.floor(Number(((_e = data === null || data === void 0 ? void 0 : data.data) === null || _e === void 0 ? void 0 : _e.totalCount) || 1) /
                        Number(exports.VISIBLE_GAMES_COUNT_OFFSET)) && react_1.default.createElement("div", { ref: sentinelRef, className: styles_module_scss_1.default.sentinel }),
            isSubmitting && (react_1.default.createElement("div", { className: styles_module_scss_1.default.loading },
                react_1.default.createElement(ui_components_1.LoadingSpinner, { size: "md" }))))) : (react_1.default.createElement(ui_components_1.EmptyGames, { text: emptyGamesText }))));
};
exports.default = GamesWithSearchAndPagination;
